import { render, staticRenderFns } from "./FilterColorsDocument.vue?vue&type=template&id=1889c898&"
import script from "./FilterColorsDocument.vue?vue&type=script&lang=ts&"
export * from "./FilterColorsDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports